import { Card } from "@/components/ui/card";
import { OnboardingForm } from "@/components/auth/OnboardingForm";

export default function Cadastro() {
  return (
    <div className="flex-1 flex items-center justify-center gradient-blur-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <Card className="max-w-md mx-auto p-8">
          <h1 className="text-3xl font-heading font-bold mb-2">Começar Agora</h1>
          <p className="text-muted-foreground mb-8">Entre com Google, Facebook, Apple ou use e-mail/telefone.</p>
          <OnboardingForm initialMode="signup" redirectAfter={(import.meta.env.VITE_POST_LOGIN_REDIRECT || "/userhome")} />
        </Card>
      </div>
    </div>
  );
}
